"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTime = exports.StyledCountdown = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledCountdown = exports.StyledCountdown = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-14dsvxs-0"
})(["border:1px solid ", ";border-radius:", ";width:81px;height:28px;font-size:", ";padding:2px 8px;display:flex;justify-content:center;align-items:center;color:", ";"], function (props) {
  return props.theme.color.default4;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.font.sizeSm;
}, function (props) {
  return props.theme.color.neutral13;
});
var StyledTime = exports.StyledTime = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-14dsvxs-1"
})(["font-weight:bold;display:inline-block;font-size:18px;color:", ";padding-right:6px;"], function (props) {
  return props.theme.color.primary6;
});